import React from 'react'
import { LayoutUsers } from './layout/LayoutUsers'

export const Users = () => {
    return (
        <LayoutUsers />
    )
}


